<div class="header-top-menu">
  <div class="d-flex flex-row side--menu">
    <div
      *ngIf="modules.home"
      class="d-flex flex-row align-items-center side--menu-item p-2 cursor-pointer"
      [ngClass]="is('home') ? 'selected' : ''"
      [routerLink]="['/home']"
      (click)="onClickTopMenu('home')"
    >
      <span class="icon icon--home" [ngClass]="selectedClass('home')"></span>
      <span [ngClass]="fontClass('home')">{{ "common.home" | translate }}</span>
      <div *ngIf="is('home')" class="active--dot"></div>
    </div>
    <div
      *ngIf="showAppreciation"
      class="d-flex flex-row align-items-center py-2 side--menu-item p-2 cursor-pointer"
      [ngClass]="is('appreciate') ? 'selected' : ''"
      [routerLink]="['/appreciate']"
    >
      <span
        class="icon icon--appreciate"
        [ngClass]="selectedClass('appreciate')"
      ></span>
      <span [ngClass]="fontClass('appreciate')">{{
        "common.appreciate" | translate
      }}</span>
      <div *ngIf="is('appreciate')" class="active--dot"></div>
    </div>
    <div
      *ngIf="showFeeds"
      class="d-flex flex-row align-items-center side--menu-item p-2 cursor-pointer"
      [ngClass]="is('feeds') ? 'selected' : ''"
      [routerLink]="['/feeds']"
      (click)="onClickTopMenu('feeds')"
    >
      <span class="icon icon--feeds" [ngClass]="selectedClass('feeds')"></span>
      <span [ngClass]="fontClass('feeds')">
        {{ "common.feeds" | translate }}
      </span>
      <div *ngIf="is('feeds')" class="active--dot"></div>
    </div>
    <div
      *ngIf="modules.rewards && showRewards"
      class="d-flex flex-row align-items-center side--menu-item p-2 cursor-pointer"
      [ngClass]="is('rewards') ? 'selected' : ''"
      [routerLink]="['/rewards']"
      (click)="onClickTopMenu('rewards')"
    >
      <span
        class="icon icon--rewards"
        [ngClass]="selectedClass('rewards')"
      ></span>
      <span [ngClass]="fontClass('rewards')">
        {{ "common.reward.n" | translate }}
      </span>
      <div *ngIf="is('rewards')" class="active--dot"></div>
    </div>
    <div
      *ngIf="modules.myWallet"
      class="d-flex flex-row align-items-center side--menu-item p-2 cursor-pointer"
      [ngClass]="is('my-wallet') ? 'selected' : ''"
      [routerLink]="['/rewards/my-wallet']"
      (click)="onClickTopMenu('my-wallet')"
    >
      <span
        class="icon icon--my-wallet"
        [ngClass]="selectedClass('my-wallet')"
      ></span>
      <span [ngClass]="fontClass('my-wallet')">
        {{ "common.myWallet" | translate }}
      </span>
      <div *ngIf="is('my-wallet')" class="active--dot"></div>
    </div>
    <div
      *ngIf="isCalendarEnabled && !isShowAnnouncementEvents"
      class="d-flex flex-row align-items-center side--menu-item p-2 cursor-pointer"
      [ngClass]="is('calendar') ? 'selected' : ''"
      [routerLink]="['/calendar']"
      (click)="onClickTopMenu('calendar')"
    >
      <span
        class="icon icon--calendar"
        [ngClass]="selectedClass('calendar')"
      ></span>
      <span [ngClass]="fontClass('calendar')">
        {{ "common.calendar" | translate }}
      </span>
      <div *ngIf="is('calendar')" class="active--dot"></div>
    </div>
    <div
      *ngIf="modules.pointsHistory"
      class="d-flex flex-row align-items-center side--menu-item p-2 cursor-pointer"
      [ngClass]="is('point-history') ? 'selected' : ''"
      [routerLink]="['/point-history']"
      [queryParams]="{ point_type: 'all', point_category: 'all' }"
      (click)="onClickTopMenu('point-history')"
    >
      <span
        class="icon icon--point-history"
        [ngClass]="selectedClass('point-history')"
      ></span>
      <span [ngClass]="fontClass('point-history')">
        {{ "common.pointsHistory" | translate }}
      </span>
      <div *ngIf="is('point-history')" class="active--dot"></div>
    </div>

    <div
      *ngIf="isCalendarEnabled && isShowAnnouncementEvents"
      class="d-flex align-items-center side--menu-item p-2 cursor-pointer"
      [ngClass]="is('announcement') ? 'selected' : ''"
      [routerLink]="['/calendar/announcement']"
      (click)="onClickTopMenu('announcement')"
    >
      <span
        class="icon icon--announcement"
        [ngClass]="selectedClass('announcement')"
      ></span>
      <span [ngClass]="fontClass('announcement')">
        {{ "common.announcements" | translate }}
      </span>
      <div *ngIf="is('announcement')" class="active--dot"></div>
    </div>

    <div
      *ngIf="isCalendarEnabled && isShowAnnouncementEvents"
      class="d-flex flex-row align-items-center side--menu-item p-2 cursor-pointer"
      [ngClass]="is('event') ? 'selected' : ''"
      [routerLink]="['/calendar/event']"
      (click)="onClickTopMenu('event')"
    >
      <span class="icon icon--event" [ngClass]="selectedClass('event')"></span>
      <span [ngClass]="fontClass('event')">
        {{ "common.events" | translate }}
      </span>
      <div *ngIf="is('event')" class="active--dot"></div>
    </div>
  </div>
</div>
